module.exports = __webpack_public_path__ + "img/foreign_w.932e4200.svg";